
import Search from "./Search"
import Pagination from "./Pagination"
import Stories from "./Stories"
import "./App.css"


const App = () => {
  
  return (
    <>
    
    <Search/>
    <Pagination/>
    <Stories/>
    </>
  )
}

export default App
